import React, { useEffect } from "react";
import { CircularProgress } from "@material-ui/core";
import {
  clearUpdateInvestmentsSuccess,
  getUsersRequest,
} from "../../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { UsersTable } from "../../../components/Table/UsersTable.js";
import {
  AdminSideNav,
  AuthNav,
} from "../../../components/Navbar/Webpages/AuthNav";
import { UsersIcon } from "@heroicons/react/outline";

const Users = () => {
  const dispatch = useDispatch();

  const {
    users,
    getUsersError,
    getUsersLoading,
    updateInvestmentsError,
    updateInvestmentsSuccess,
  } = useSelector((state) => {
    const {
      success: { updateInvestments: updateInvestmentsSuccess },
      errors: {
        getUsers: getUsersError,
        updateInvestments: updateInvestmentsError,
      },
    } = state.ajaxStatuses;
    const { getUsersLoading } = state.loadingIndicator;
    const { users } = state.userData;

    return {
      users,
      getUsersError,
      updateInvestmentsError,
      updateInvestmentsSuccess,
      getUsersLoading,
    };
  });

  useEffect(() => {
    dispatch(getUsersRequest());
  }, [dispatch]);

  useEffect(() => {
    if (getUsersError) toast.error(getUsersError);
    if (updateInvestmentsError) toast.error(updateInvestmentsError);
    if (updateInvestmentsSuccess) {
      toast.success(updateInvestmentsSuccess);
      dispatch(clearUpdateInvestmentsSuccess());
    }
  }, [
    getUsersError,
    updateInvestmentsError,
    updateInvestmentsSuccess,
    dispatch,
  ]);

  return (
    <div className="min-h-screen bg-gray-50">
      <AuthNav title={"Admin Users"} />
      <AdminSideNav />

      {/* Main Content Area */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 mb-20">
        {/* Header Section */}
        <div className="flex items-center gap-4 mb-8 mt-14">
          <div className="p-3 bg-white rounded-full shadow-sm text-primary">
            <UsersIcon className="w-6 h-6" />
          </div>
          <div className="flex-1">
            <h1 className="text-2xl font-heading font-bold text-gray-900">
              User Management
            </h1>
            <p className="text-sm text-gray-500 font-body">
              Monitor and manage {users?.length || 0} registered accounts
            </p>
          </div>
          {/* Quick Stat Pill */}
          <div className="hidden sm:flex bg-white px-4 py-2 rounded-full shadow-sm border border-gray-100 items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
            <span className="text-xs font-bold text-gray-600 uppercase">
              System Active
            </span>
          </div>
        </div>

        {/* Users Table / List */}
        <div className="w-full">
          {getUsersLoading ? (
            <div className="flex flex-col items-center justify-center py-32">
              <CircularProgress size={40} style={{ color: "#4F46E5" }} />
              <p className="mt-4 text-gray-500 font-medium text-sm">
                Synchronizing user database...
              </p>
            </div>
          ) : (
            <UsersTable users={users || []} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Users;
